/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PepVidaResultadoRouteImport } from './routes/pep-vida/resultado'
import { Route as PepVidaLoginRouteImport } from './routes/pep-vida/login'
import { Route as PepVidaAuthedRouteImport } from './routes/pep-vida/_authed'
import { Route as PepVidaAuthedIndexRouteImport } from './routes/pep-vida/_authed/index'
import { Route as PepVidaAuthedProntuariosExportacaoRouteImport } from './routes/pep-vida/_authed/prontuarios-exportacao'
import { Route as PepVidaAuthedModelosDocumentosRouteImport } from './routes/pep-vida/_authed/modelos-documentos'
import { Route as PepVidaAuthedDashboardRouteImport } from './routes/pep-vida/_authed/dashboard'
import { Route as PepVidaAuthedAgendaRouteImport } from './routes/pep-vida/_authed/agenda'
import { Route as PepVidaAuthedPacientesIndexRouteImport } from './routes/pep-vida/_authed/pacientes.index'
import { Route as PepVidaAuthedAtendimentosIndexRouteImport } from './routes/pep-vida/_authed/atendimentos.index'
import { Route as PepVidaResultadoProtocoloCdPacienteRouteImport } from './routes/pep-vida/resultado.$protocolo.$cdPaciente'
import { Route as PepVidaAuthedPacientesCdPacienteRouteImport } from './routes/pep-vida/_authed/pacientes.$cdPaciente'
import { Route as PepVidaAuthedLaudosCdLaudoRouteImport } from './routes/pep-vida/_authed/laudos.$cdLaudo'
import { Route as PepVidaAuthedConsultasIdRouteImport } from './routes/pep-vida/_authed/consultas.$id'
import { Route as PepVidaAuthedConsultasHistoricoIdRouteImport } from './routes/pep-vida/_authed/consultas-historico.$id'
import { Route as PepVidaAuthedAtendimentosCdAtendimentoRouteImport } from './routes/pep-vida/_authed/atendimentos.$cdAtendimento'
import { Route as PepVidaAuthedPacientesCdPacienteHistoricoRouteImport } from './routes/pep-vida/_authed/pacientes.$cdPaciente.historico'
import { Route as PepVidaAuthedPacientesCdPacienteExamesRouteImport } from './routes/pep-vida/_authed/pacientes.$cdPaciente.exames'
import { Route as PepVidaAuthedPacientesCdPacienteDocumentosRouteImport } from './routes/pep-vida/_authed/pacientes.$cdPaciente.documentos'
import { Route as PepVidaAuthedConsultasIdHistoricoRouteImport } from './routes/pep-vida/_authed/consultas.$id.historico'

const PepVidaResultadoRoute = PepVidaResultadoRouteImport.update({
  id: '/pep-vida/resultado',
  path: '/pep-vida/resultado',
  getParentRoute: () => rootRouteImport,
} as any)
const PepVidaLoginRoute = PepVidaLoginRouteImport.update({
  id: '/pep-vida/login',
  path: '/pep-vida/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PepVidaAuthedRoute = PepVidaAuthedRouteImport.update({
  id: '/pep-vida/_authed',
  path: '/pep-vida',
  getParentRoute: () => rootRouteImport,
} as any)
const PepVidaAuthedIndexRoute = PepVidaAuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PepVidaAuthedRoute,
} as any)
const PepVidaAuthedProntuariosExportacaoRoute =
  PepVidaAuthedProntuariosExportacaoRouteImport.update({
    id: '/prontuarios-exportacao',
    path: '/prontuarios-exportacao',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedModelosDocumentosRoute =
  PepVidaAuthedModelosDocumentosRouteImport.update({
    id: '/modelos-documentos',
    path: '/modelos-documentos',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedDashboardRoute = PepVidaAuthedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => PepVidaAuthedRoute,
} as any)
const PepVidaAuthedAgendaRoute = PepVidaAuthedAgendaRouteImport.update({
  id: '/agenda',
  path: '/agenda',
  getParentRoute: () => PepVidaAuthedRoute,
} as any)
const PepVidaAuthedPacientesIndexRoute =
  PepVidaAuthedPacientesIndexRouteImport.update({
    id: '/pacientes/',
    path: '/pacientes/',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedAtendimentosIndexRoute =
  PepVidaAuthedAtendimentosIndexRouteImport.update({
    id: '/atendimentos/',
    path: '/atendimentos/',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaResultadoProtocoloCdPacienteRoute =
  PepVidaResultadoProtocoloCdPacienteRouteImport.update({
    id: '/$protocolo/$cdPaciente',
    path: '/$protocolo/$cdPaciente',
    getParentRoute: () => PepVidaResultadoRoute,
  } as any)
const PepVidaAuthedPacientesCdPacienteRoute =
  PepVidaAuthedPacientesCdPacienteRouteImport.update({
    id: '/pacientes/$cdPaciente',
    path: '/pacientes/$cdPaciente',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedLaudosCdLaudoRoute =
  PepVidaAuthedLaudosCdLaudoRouteImport.update({
    id: '/laudos/$cdLaudo',
    path: '/laudos/$cdLaudo',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedConsultasIdRoute =
  PepVidaAuthedConsultasIdRouteImport.update({
    id: '/consultas/$id',
    path: '/consultas/$id',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedConsultasHistoricoIdRoute =
  PepVidaAuthedConsultasHistoricoIdRouteImport.update({
    id: '/consultas-historico/$id',
    path: '/consultas-historico/$id',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedAtendimentosCdAtendimentoRoute =
  PepVidaAuthedAtendimentosCdAtendimentoRouteImport.update({
    id: '/atendimentos/$cdAtendimento',
    path: '/atendimentos/$cdAtendimento',
    getParentRoute: () => PepVidaAuthedRoute,
  } as any)
const PepVidaAuthedPacientesCdPacienteHistoricoRoute =
  PepVidaAuthedPacientesCdPacienteHistoricoRouteImport.update({
    id: '/historico',
    path: '/historico',
    getParentRoute: () => PepVidaAuthedPacientesCdPacienteRoute,
  } as any)
const PepVidaAuthedPacientesCdPacienteExamesRoute =
  PepVidaAuthedPacientesCdPacienteExamesRouteImport.update({
    id: '/exames',
    path: '/exames',
    getParentRoute: () => PepVidaAuthedPacientesCdPacienteRoute,
  } as any)
const PepVidaAuthedPacientesCdPacienteDocumentosRoute =
  PepVidaAuthedPacientesCdPacienteDocumentosRouteImport.update({
    id: '/documentos',
    path: '/documentos',
    getParentRoute: () => PepVidaAuthedPacientesCdPacienteRoute,
  } as any)
const PepVidaAuthedConsultasIdHistoricoRoute =
  PepVidaAuthedConsultasIdHistoricoRouteImport.update({
    id: '/historico',
    path: '/historico',
    getParentRoute: () => PepVidaAuthedConsultasIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/pep-vida': typeof PepVidaAuthedRouteWithChildren
  '/pep-vida/login': typeof PepVidaLoginRoute
  '/pep-vida/resultado': typeof PepVidaResultadoRouteWithChildren
  '/pep-vida/agenda': typeof PepVidaAuthedAgendaRoute
  '/pep-vida/dashboard': typeof PepVidaAuthedDashboardRoute
  '/pep-vida/modelos-documentos': typeof PepVidaAuthedModelosDocumentosRoute
  '/pep-vida/prontuarios-exportacao': typeof PepVidaAuthedProntuariosExportacaoRoute
  '/pep-vida/': typeof PepVidaAuthedIndexRoute
  '/pep-vida/atendimentos/$cdAtendimento': typeof PepVidaAuthedAtendimentosCdAtendimentoRoute
  '/pep-vida/consultas-historico/$id': typeof PepVidaAuthedConsultasHistoricoIdRoute
  '/pep-vida/consultas/$id': typeof PepVidaAuthedConsultasIdRouteWithChildren
  '/pep-vida/laudos/$cdLaudo': typeof PepVidaAuthedLaudosCdLaudoRoute
  '/pep-vida/pacientes/$cdPaciente': typeof PepVidaAuthedPacientesCdPacienteRouteWithChildren
  '/pep-vida/resultado/$protocolo/$cdPaciente': typeof PepVidaResultadoProtocoloCdPacienteRoute
  '/pep-vida/atendimentos/': typeof PepVidaAuthedAtendimentosIndexRoute
  '/pep-vida/pacientes/': typeof PepVidaAuthedPacientesIndexRoute
  '/pep-vida/consultas/$id/historico': typeof PepVidaAuthedConsultasIdHistoricoRoute
  '/pep-vida/pacientes/$cdPaciente/documentos': typeof PepVidaAuthedPacientesCdPacienteDocumentosRoute
  '/pep-vida/pacientes/$cdPaciente/exames': typeof PepVidaAuthedPacientesCdPacienteExamesRoute
  '/pep-vida/pacientes/$cdPaciente/historico': typeof PepVidaAuthedPacientesCdPacienteHistoricoRoute
}
export interface FileRoutesByTo {
  '/pep-vida/login': typeof PepVidaLoginRoute
  '/pep-vida/resultado': typeof PepVidaResultadoRouteWithChildren
  '/pep-vida/agenda': typeof PepVidaAuthedAgendaRoute
  '/pep-vida/dashboard': typeof PepVidaAuthedDashboardRoute
  '/pep-vida/modelos-documentos': typeof PepVidaAuthedModelosDocumentosRoute
  '/pep-vida/prontuarios-exportacao': typeof PepVidaAuthedProntuariosExportacaoRoute
  '/pep-vida': typeof PepVidaAuthedIndexRoute
  '/pep-vida/atendimentos/$cdAtendimento': typeof PepVidaAuthedAtendimentosCdAtendimentoRoute
  '/pep-vida/consultas-historico/$id': typeof PepVidaAuthedConsultasHistoricoIdRoute
  '/pep-vida/consultas/$id': typeof PepVidaAuthedConsultasIdRouteWithChildren
  '/pep-vida/laudos/$cdLaudo': typeof PepVidaAuthedLaudosCdLaudoRoute
  '/pep-vida/pacientes/$cdPaciente': typeof PepVidaAuthedPacientesCdPacienteRouteWithChildren
  '/pep-vida/resultado/$protocolo/$cdPaciente': typeof PepVidaResultadoProtocoloCdPacienteRoute
  '/pep-vida/atendimentos': typeof PepVidaAuthedAtendimentosIndexRoute
  '/pep-vida/pacientes': typeof PepVidaAuthedPacientesIndexRoute
  '/pep-vida/consultas/$id/historico': typeof PepVidaAuthedConsultasIdHistoricoRoute
  '/pep-vida/pacientes/$cdPaciente/documentos': typeof PepVidaAuthedPacientesCdPacienteDocumentosRoute
  '/pep-vida/pacientes/$cdPaciente/exames': typeof PepVidaAuthedPacientesCdPacienteExamesRoute
  '/pep-vida/pacientes/$cdPaciente/historico': typeof PepVidaAuthedPacientesCdPacienteHistoricoRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/pep-vida/_authed': typeof PepVidaAuthedRouteWithChildren
  '/pep-vida/login': typeof PepVidaLoginRoute
  '/pep-vida/resultado': typeof PepVidaResultadoRouteWithChildren
  '/pep-vida/_authed/agenda': typeof PepVidaAuthedAgendaRoute
  '/pep-vida/_authed/dashboard': typeof PepVidaAuthedDashboardRoute
  '/pep-vida/_authed/modelos-documentos': typeof PepVidaAuthedModelosDocumentosRoute
  '/pep-vida/_authed/prontuarios-exportacao': typeof PepVidaAuthedProntuariosExportacaoRoute
  '/pep-vida/_authed/': typeof PepVidaAuthedIndexRoute
  '/pep-vida/_authed/atendimentos/$cdAtendimento': typeof PepVidaAuthedAtendimentosCdAtendimentoRoute
  '/pep-vida/_authed/consultas-historico/$id': typeof PepVidaAuthedConsultasHistoricoIdRoute
  '/pep-vida/_authed/consultas/$id': typeof PepVidaAuthedConsultasIdRouteWithChildren
  '/pep-vida/_authed/laudos/$cdLaudo': typeof PepVidaAuthedLaudosCdLaudoRoute
  '/pep-vida/_authed/pacientes/$cdPaciente': typeof PepVidaAuthedPacientesCdPacienteRouteWithChildren
  '/pep-vida/resultado/$protocolo/$cdPaciente': typeof PepVidaResultadoProtocoloCdPacienteRoute
  '/pep-vida/_authed/atendimentos/': typeof PepVidaAuthedAtendimentosIndexRoute
  '/pep-vida/_authed/pacientes/': typeof PepVidaAuthedPacientesIndexRoute
  '/pep-vida/_authed/consultas/$id/historico': typeof PepVidaAuthedConsultasIdHistoricoRoute
  '/pep-vida/_authed/pacientes/$cdPaciente/documentos': typeof PepVidaAuthedPacientesCdPacienteDocumentosRoute
  '/pep-vida/_authed/pacientes/$cdPaciente/exames': typeof PepVidaAuthedPacientesCdPacienteExamesRoute
  '/pep-vida/_authed/pacientes/$cdPaciente/historico': typeof PepVidaAuthedPacientesCdPacienteHistoricoRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/pep-vida'
    | '/pep-vida/login'
    | '/pep-vida/resultado'
    | '/pep-vida/agenda'
    | '/pep-vida/dashboard'
    | '/pep-vida/modelos-documentos'
    | '/pep-vida/prontuarios-exportacao'
    | '/pep-vida/'
    | '/pep-vida/atendimentos/$cdAtendimento'
    | '/pep-vida/consultas-historico/$id'
    | '/pep-vida/consultas/$id'
    | '/pep-vida/laudos/$cdLaudo'
    | '/pep-vida/pacientes/$cdPaciente'
    | '/pep-vida/resultado/$protocolo/$cdPaciente'
    | '/pep-vida/atendimentos/'
    | '/pep-vida/pacientes/'
    | '/pep-vida/consultas/$id/historico'
    | '/pep-vida/pacientes/$cdPaciente/documentos'
    | '/pep-vida/pacientes/$cdPaciente/exames'
    | '/pep-vida/pacientes/$cdPaciente/historico'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/pep-vida/login'
    | '/pep-vida/resultado'
    | '/pep-vida/agenda'
    | '/pep-vida/dashboard'
    | '/pep-vida/modelos-documentos'
    | '/pep-vida/prontuarios-exportacao'
    | '/pep-vida'
    | '/pep-vida/atendimentos/$cdAtendimento'
    | '/pep-vida/consultas-historico/$id'
    | '/pep-vida/consultas/$id'
    | '/pep-vida/laudos/$cdLaudo'
    | '/pep-vida/pacientes/$cdPaciente'
    | '/pep-vida/resultado/$protocolo/$cdPaciente'
    | '/pep-vida/atendimentos'
    | '/pep-vida/pacientes'
    | '/pep-vida/consultas/$id/historico'
    | '/pep-vida/pacientes/$cdPaciente/documentos'
    | '/pep-vida/pacientes/$cdPaciente/exames'
    | '/pep-vida/pacientes/$cdPaciente/historico'
  id:
    | '__root__'
    | '/pep-vida/_authed'
    | '/pep-vida/login'
    | '/pep-vida/resultado'
    | '/pep-vida/_authed/agenda'
    | '/pep-vida/_authed/dashboard'
    | '/pep-vida/_authed/modelos-documentos'
    | '/pep-vida/_authed/prontuarios-exportacao'
    | '/pep-vida/_authed/'
    | '/pep-vida/_authed/atendimentos/$cdAtendimento'
    | '/pep-vida/_authed/consultas-historico/$id'
    | '/pep-vida/_authed/consultas/$id'
    | '/pep-vida/_authed/laudos/$cdLaudo'
    | '/pep-vida/_authed/pacientes/$cdPaciente'
    | '/pep-vida/resultado/$protocolo/$cdPaciente'
    | '/pep-vida/_authed/atendimentos/'
    | '/pep-vida/_authed/pacientes/'
    | '/pep-vida/_authed/consultas/$id/historico'
    | '/pep-vida/_authed/pacientes/$cdPaciente/documentos'
    | '/pep-vida/_authed/pacientes/$cdPaciente/exames'
    | '/pep-vida/_authed/pacientes/$cdPaciente/historico'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  PepVidaAuthedRoute: typeof PepVidaAuthedRouteWithChildren
  PepVidaLoginRoute: typeof PepVidaLoginRoute
  PepVidaResultadoRoute: typeof PepVidaResultadoRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/pep-vida/resultado': {
      id: '/pep-vida/resultado'
      path: '/pep-vida/resultado'
      fullPath: '/pep-vida/resultado'
      preLoaderRoute: typeof PepVidaResultadoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pep-vida/login': {
      id: '/pep-vida/login'
      path: '/pep-vida/login'
      fullPath: '/pep-vida/login'
      preLoaderRoute: typeof PepVidaLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pep-vida/_authed': {
      id: '/pep-vida/_authed'
      path: '/pep-vida'
      fullPath: '/pep-vida'
      preLoaderRoute: typeof PepVidaAuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pep-vida/_authed/': {
      id: '/pep-vida/_authed/'
      path: '/'
      fullPath: '/pep-vida/'
      preLoaderRoute: typeof PepVidaAuthedIndexRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/prontuarios-exportacao': {
      id: '/pep-vida/_authed/prontuarios-exportacao'
      path: '/prontuarios-exportacao'
      fullPath: '/pep-vida/prontuarios-exportacao'
      preLoaderRoute: typeof PepVidaAuthedProntuariosExportacaoRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/modelos-documentos': {
      id: '/pep-vida/_authed/modelos-documentos'
      path: '/modelos-documentos'
      fullPath: '/pep-vida/modelos-documentos'
      preLoaderRoute: typeof PepVidaAuthedModelosDocumentosRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/dashboard': {
      id: '/pep-vida/_authed/dashboard'
      path: '/dashboard'
      fullPath: '/pep-vida/dashboard'
      preLoaderRoute: typeof PepVidaAuthedDashboardRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/agenda': {
      id: '/pep-vida/_authed/agenda'
      path: '/agenda'
      fullPath: '/pep-vida/agenda'
      preLoaderRoute: typeof PepVidaAuthedAgendaRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/pacientes/': {
      id: '/pep-vida/_authed/pacientes/'
      path: '/pacientes'
      fullPath: '/pep-vida/pacientes/'
      preLoaderRoute: typeof PepVidaAuthedPacientesIndexRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/atendimentos/': {
      id: '/pep-vida/_authed/atendimentos/'
      path: '/atendimentos'
      fullPath: '/pep-vida/atendimentos/'
      preLoaderRoute: typeof PepVidaAuthedAtendimentosIndexRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/resultado/$protocolo/$cdPaciente': {
      id: '/pep-vida/resultado/$protocolo/$cdPaciente'
      path: '/$protocolo/$cdPaciente'
      fullPath: '/pep-vida/resultado/$protocolo/$cdPaciente'
      preLoaderRoute: typeof PepVidaResultadoProtocoloCdPacienteRouteImport
      parentRoute: typeof PepVidaResultadoRoute
    }
    '/pep-vida/_authed/pacientes/$cdPaciente': {
      id: '/pep-vida/_authed/pacientes/$cdPaciente'
      path: '/pacientes/$cdPaciente'
      fullPath: '/pep-vida/pacientes/$cdPaciente'
      preLoaderRoute: typeof PepVidaAuthedPacientesCdPacienteRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/laudos/$cdLaudo': {
      id: '/pep-vida/_authed/laudos/$cdLaudo'
      path: '/laudos/$cdLaudo'
      fullPath: '/pep-vida/laudos/$cdLaudo'
      preLoaderRoute: typeof PepVidaAuthedLaudosCdLaudoRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/consultas/$id': {
      id: '/pep-vida/_authed/consultas/$id'
      path: '/consultas/$id'
      fullPath: '/pep-vida/consultas/$id'
      preLoaderRoute: typeof PepVidaAuthedConsultasIdRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/consultas-historico/$id': {
      id: '/pep-vida/_authed/consultas-historico/$id'
      path: '/consultas-historico/$id'
      fullPath: '/pep-vida/consultas-historico/$id'
      preLoaderRoute: typeof PepVidaAuthedConsultasHistoricoIdRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/atendimentos/$cdAtendimento': {
      id: '/pep-vida/_authed/atendimentos/$cdAtendimento'
      path: '/atendimentos/$cdAtendimento'
      fullPath: '/pep-vida/atendimentos/$cdAtendimento'
      preLoaderRoute: typeof PepVidaAuthedAtendimentosCdAtendimentoRouteImport
      parentRoute: typeof PepVidaAuthedRoute
    }
    '/pep-vida/_authed/pacientes/$cdPaciente/historico': {
      id: '/pep-vida/_authed/pacientes/$cdPaciente/historico'
      path: '/historico'
      fullPath: '/pep-vida/pacientes/$cdPaciente/historico'
      preLoaderRoute: typeof PepVidaAuthedPacientesCdPacienteHistoricoRouteImport
      parentRoute: typeof PepVidaAuthedPacientesCdPacienteRoute
    }
    '/pep-vida/_authed/pacientes/$cdPaciente/exames': {
      id: '/pep-vida/_authed/pacientes/$cdPaciente/exames'
      path: '/exames'
      fullPath: '/pep-vida/pacientes/$cdPaciente/exames'
      preLoaderRoute: typeof PepVidaAuthedPacientesCdPacienteExamesRouteImport
      parentRoute: typeof PepVidaAuthedPacientesCdPacienteRoute
    }
    '/pep-vida/_authed/pacientes/$cdPaciente/documentos': {
      id: '/pep-vida/_authed/pacientes/$cdPaciente/documentos'
      path: '/documentos'
      fullPath: '/pep-vida/pacientes/$cdPaciente/documentos'
      preLoaderRoute: typeof PepVidaAuthedPacientesCdPacienteDocumentosRouteImport
      parentRoute: typeof PepVidaAuthedPacientesCdPacienteRoute
    }
    '/pep-vida/_authed/consultas/$id/historico': {
      id: '/pep-vida/_authed/consultas/$id/historico'
      path: '/historico'
      fullPath: '/pep-vida/consultas/$id/historico'
      preLoaderRoute: typeof PepVidaAuthedConsultasIdHistoricoRouteImport
      parentRoute: typeof PepVidaAuthedConsultasIdRoute
    }
  }
}

interface PepVidaAuthedConsultasIdRouteChildren {
  PepVidaAuthedConsultasIdHistoricoRoute: typeof PepVidaAuthedConsultasIdHistoricoRoute
}

const PepVidaAuthedConsultasIdRouteChildren: PepVidaAuthedConsultasIdRouteChildren =
  {
    PepVidaAuthedConsultasIdHistoricoRoute:
      PepVidaAuthedConsultasIdHistoricoRoute,
  }

const PepVidaAuthedConsultasIdRouteWithChildren =
  PepVidaAuthedConsultasIdRoute._addFileChildren(
    PepVidaAuthedConsultasIdRouteChildren,
  )

interface PepVidaAuthedPacientesCdPacienteRouteChildren {
  PepVidaAuthedPacientesCdPacienteDocumentosRoute: typeof PepVidaAuthedPacientesCdPacienteDocumentosRoute
  PepVidaAuthedPacientesCdPacienteExamesRoute: typeof PepVidaAuthedPacientesCdPacienteExamesRoute
  PepVidaAuthedPacientesCdPacienteHistoricoRoute: typeof PepVidaAuthedPacientesCdPacienteHistoricoRoute
}

const PepVidaAuthedPacientesCdPacienteRouteChildren: PepVidaAuthedPacientesCdPacienteRouteChildren =
  {
    PepVidaAuthedPacientesCdPacienteDocumentosRoute:
      PepVidaAuthedPacientesCdPacienteDocumentosRoute,
    PepVidaAuthedPacientesCdPacienteExamesRoute:
      PepVidaAuthedPacientesCdPacienteExamesRoute,
    PepVidaAuthedPacientesCdPacienteHistoricoRoute:
      PepVidaAuthedPacientesCdPacienteHistoricoRoute,
  }

const PepVidaAuthedPacientesCdPacienteRouteWithChildren =
  PepVidaAuthedPacientesCdPacienteRoute._addFileChildren(
    PepVidaAuthedPacientesCdPacienteRouteChildren,
  )

interface PepVidaAuthedRouteChildren {
  PepVidaAuthedAgendaRoute: typeof PepVidaAuthedAgendaRoute
  PepVidaAuthedDashboardRoute: typeof PepVidaAuthedDashboardRoute
  PepVidaAuthedModelosDocumentosRoute: typeof PepVidaAuthedModelosDocumentosRoute
  PepVidaAuthedProntuariosExportacaoRoute: typeof PepVidaAuthedProntuariosExportacaoRoute
  PepVidaAuthedIndexRoute: typeof PepVidaAuthedIndexRoute
  PepVidaAuthedAtendimentosCdAtendimentoRoute: typeof PepVidaAuthedAtendimentosCdAtendimentoRoute
  PepVidaAuthedConsultasHistoricoIdRoute: typeof PepVidaAuthedConsultasHistoricoIdRoute
  PepVidaAuthedConsultasIdRoute: typeof PepVidaAuthedConsultasIdRouteWithChildren
  PepVidaAuthedLaudosCdLaudoRoute: typeof PepVidaAuthedLaudosCdLaudoRoute
  PepVidaAuthedPacientesCdPacienteRoute: typeof PepVidaAuthedPacientesCdPacienteRouteWithChildren
  PepVidaAuthedAtendimentosIndexRoute: typeof PepVidaAuthedAtendimentosIndexRoute
  PepVidaAuthedPacientesIndexRoute: typeof PepVidaAuthedPacientesIndexRoute
}

const PepVidaAuthedRouteChildren: PepVidaAuthedRouteChildren = {
  PepVidaAuthedAgendaRoute: PepVidaAuthedAgendaRoute,
  PepVidaAuthedDashboardRoute: PepVidaAuthedDashboardRoute,
  PepVidaAuthedModelosDocumentosRoute: PepVidaAuthedModelosDocumentosRoute,
  PepVidaAuthedProntuariosExportacaoRoute:
    PepVidaAuthedProntuariosExportacaoRoute,
  PepVidaAuthedIndexRoute: PepVidaAuthedIndexRoute,
  PepVidaAuthedAtendimentosCdAtendimentoRoute:
    PepVidaAuthedAtendimentosCdAtendimentoRoute,
  PepVidaAuthedConsultasHistoricoIdRoute:
    PepVidaAuthedConsultasHistoricoIdRoute,
  PepVidaAuthedConsultasIdRoute: PepVidaAuthedConsultasIdRouteWithChildren,
  PepVidaAuthedLaudosCdLaudoRoute: PepVidaAuthedLaudosCdLaudoRoute,
  PepVidaAuthedPacientesCdPacienteRoute:
    PepVidaAuthedPacientesCdPacienteRouteWithChildren,
  PepVidaAuthedAtendimentosIndexRoute: PepVidaAuthedAtendimentosIndexRoute,
  PepVidaAuthedPacientesIndexRoute: PepVidaAuthedPacientesIndexRoute,
}

const PepVidaAuthedRouteWithChildren = PepVidaAuthedRoute._addFileChildren(
  PepVidaAuthedRouteChildren,
)

interface PepVidaResultadoRouteChildren {
  PepVidaResultadoProtocoloCdPacienteRoute: typeof PepVidaResultadoProtocoloCdPacienteRoute
}

const PepVidaResultadoRouteChildren: PepVidaResultadoRouteChildren = {
  PepVidaResultadoProtocoloCdPacienteRoute:
    PepVidaResultadoProtocoloCdPacienteRoute,
}

const PepVidaResultadoRouteWithChildren =
  PepVidaResultadoRoute._addFileChildren(PepVidaResultadoRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  PepVidaAuthedRoute: PepVidaAuthedRouteWithChildren,
  PepVidaLoginRoute: PepVidaLoginRoute,
  PepVidaResultadoRoute: PepVidaResultadoRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
